import React, { useEffect } from 'react';
import './BTS.css';

function BTS() {
    useEffect(() => {
        // If the script already exists, just re-process
        if (window.instgrm) {
            window.instgrm.Embeds.process();
            return;
        }

        // Otherwise load it
        const script = document.createElement('script');
        script.src = 'https://www.instagram.com/embed.js';
        script.async = true;
        script.onload = () => {
            if (window.instgrm) {
                window.instgrm.Embeds.process();
            }
        };
        document.body.appendChild(script);
    }, []);

    return (
        <div className="BTS">
            <img
                className="btsTiles"
                alt="bts-tiles"
                loading="lazy"
                src="bts tiles.png"
            />

            <div className="text">
                Watch our launch video here! We discuss the idea behind the show, the night of the event, and what we learned from the experience ☺
            </div>

            <div className="instagramWrapper">
                <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/p/DS_NKRljz4b/"
                    data-instgrm-version="14"
                    style={{ margin: '0 auto' }}
                />
            </div>
        </div>
    );
}

export default BTS;
